import * as yup from 'yup';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import _get from 'lodash/get';
import { Row, RenderConfig, TextInput, SelectInput, EMPTY_STRING } from 'commons-ui';

import { FORM_FIELD_KEYS, MERCHANTS_NAME } from './constants';

export const validationSchema = yup.object().shape({
	merchantName: yup
		.string()
		.test('len', 'merchantName is required', (val) => !val || val.length > 0)
		.required('merchantName is required'),
	orderId: yup
		.string()
		.test('len', 'orderId is required', (val) => !val || val.length > 0)
		.required('orderId is required')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.MERCHANT_NAME]: new RenderConfig()
		.setName('merchantName')
		.setLabel('Merchant Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: _map(_keys(MERCHANTS_NAME), (key) => ({ id: _get(MERCHANTS_NAME, [key], EMPTY_STRING), label: key }))
		}),
	[FORM_FIELD_KEYS.ORDER_ID]: new RenderConfig()
		.setName('orderId')
		.setLabel('Order Id')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.MERCHANT_NAME), new Row(FORM_FIELD_KEYS.ORDER_ID)];
